import './AiAssistantWidgetPill.css';

import {twx} from '../../utils/tailwindUtils';
import {AnimatedHeight} from '../AnimatedHeight/AnimatedHeight';
import {CrossFade} from '../CrossFade/CrossFade';
import AiAssistantAura from './AiAssistantAura';

const PILL_SHAPES = {
    COLLAPSED: 'collapsed',
    EXPANDED: 'expanded',
};

const COLLAPSED_WIDTH = 'w-[243px] max-w-full';

// Clips the content to the narrower collapsed background without narrowing its box, which would rewrap text
const COLLAPSED_CLIP = '[clip-path:inset(0px_calc((100%_-_243px)/2)_round_45px)]';
const EXPANDED_CLIP = '[clip-path:inset(0px_0px_round_32px)]';

// clip-path, not rounded overflow: Safari lets the aura's GPU layers spill past that
const AURA_COLLAPSED_CLIP = '[clip-path:inset(0px_round_45px)]';
const AURA_EXPANDED_CLIP = '[clip-path:inset(0px_round_32px)]';

const AiAssistantWidgetPill = ({isExpanded, isFaded, collapsedBody, expandedBody}) => {
    // Fixed-width boxes, so the content never reflows while the background resizes
    const bodies = {
        [PILL_SHAPES.COLLAPSED]: <div className={twx('mx-auto px-7', COLLAPSED_WIDTH)}>{collapsedBody}</div>,
        [PILL_SHAPES.EXPANDED]: <div className='p-6'>{expandedBody}</div>,
    };

    return (
        // Fixed at the widest shape, so the layout never moves. Children fade separately: opacity on a parent
        // breaks the backdrop blur
        <div className='relative mx-auto w-[353px] max-w-[calc(100%-2rem)]'>
            <div
                className={twx(
                    'ai-assistant-widget-pill absolute inset-y-0 left-1/2 -translate-x-1/2 overflow-hidden',
                    'bg-[#0F0F0F]/[0.9] backdrop-blur-[8px]',
                    // duration-200 must match animationDurations.STATE_CHANGE_MS
                    'transition-[width,border-radius,opacity] duration-200 ease-in-out',
                    isFaded && 'opacity-0',
                    // Half the 90px height: round like rounded-full, but can animate to 32px
                    isExpanded ? 'w-full rounded-[32px]' : ['rounded-[45px]', COLLAPSED_WIDTH]
                )}
            >
                <AiAssistantAura
                    className={twx(
                        'absolute inset-0 transition-[clip-path] duration-200 ease-in-out',
                        isExpanded ? AURA_EXPANDED_CLIP : AURA_COLLAPSED_CLIP
                    )}
                />
            </div>

            <AnimatedHeight
                className={twx(
                    'relative transition-[clip-path,opacity] duration-200 ease-in-out',
                    isFaded && 'opacity-0',
                    isExpanded ? EXPANDED_CLIP : COLLAPSED_CLIP
                )}
            >
                <CrossFade
                    activeKey={isExpanded ? PILL_SHAPES.EXPANDED : PILL_SHAPES.COLLAPSED}
                    layers={bodies}
                    isSizedToActiveLayer
                />
            </AnimatedHeight>
        </div>
    );
};

export default AiAssistantWidgetPill;
